<form nz-form nzLayout="vertical" [formGroup]="reportFilterForm">
    <div nz-row nzGutter="24" style="width: 100%">
        @if(reportFilterForm.controls['displayBy']){
        <div nz-col [nzSm]="5" [nzXs]="24" class="radio-group-container">
            <nz-form-item>
                <nz-form-label nzFor="DisplayBy" class="ppl-form-label report-label">
                    Display By
                </nz-form-label>
                <nz-form-control style="width: 100%">
                    <nz-radio-group formControlName="displayBy" nzButtonStyle="solid">
                        <label nz-radio-button nzValue="count">Denied Count</label>
                        <label nz-radio-button nzValue="amount">Denied Amount</label>
                    </nz-radio-group>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(reportFilterForm.controls['resubDate']){
        <div nz-col [nzSm]="4" [nzXs]="24" class="radio-group-container">
            <nz-form-item>
                <nz-form-label nzFor="resubDate" class="ppl-form-label report-label">
                    Resub Date
                </nz-form-label>
                <nz-form-control style="width: 100%">
                    <div>
                        <ppl-dropdown-select formControlName="resubDate" class="ppl-select" id="resubDate"
                            [options]="resubDates" [optionLabel]="'date'" [optionValue]="'date'"
                            placeholder="Resub Dates" />
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }

        @if(reportFilterForm.controls['metricType']){
        <div nz-col [nzSm]="metricType.length > 2 ? 8 : 5" [nzXs]="24" class="radio-group-container">
            <nz-form-item>
                <nz-form-label nzFor="metricType" class="ppl-form-label report-label">
                    Metric Type
                </nz-form-label>
                <nz-form-control style="width: 100%">
                    <nz-radio-group formControlName="metricType" nzButtonStyle="solid">
                        @for(option of metricType; track $index) {
                        <label nz-radio-button [nzValue]="option.key"> {{ option.label }} </label>
                        }
                    </nz-radio-group>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(showMCOFilter){
        @if(reportFilterForm.controls['mcoName']){
        <div nz-col [nzSm]="4" [nzXs]="24">
            <nz-form-item style="margin-bottom:8px; width: 100%">
                <nz-form-label nzFor="mcoName" class="ppl-form-label report-label">
                    MCO Name
                </nz-form-label>
                <nz-form-control style="width: 100%;">
                    <div>
                        <ppl-dropdown-select formControlName="mcoName" class="ppl-select" id="mcoName"
                            [options]="mcoList" [optionLabel]="'orgName'" [optionValue]="'orgName'"
                            placeholder="MCO Name" />
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        }
        @if (!showMCOFilter) {
        @if(reportFilterForm.controls['ignoreReason']){
        <div nz-col [nzSm]="4" [nzXs]="24">
            <nz-form-item style="margin-bottom:8px; width: 100%">
                <nz-form-label nzFor="ignoreReason" class="ppl-form-label report-label">
                    Ignore Reason
                </nz-form-label>
                <nz-form-control style="width: 100%;">
                    <div>
                        <ppl-dropdown-select formControlName="ignoreReason" class="ppl-select" id="ignoreReason"
                            [options]="ignoreReasonList" [optionLabel]="'ignoreReason'" [optionValue]="'ignoreReason'"
                            placeholder="Ignore Reason" />
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        }
        @if(showResubReasonFilter){
        @if(reportFilterForm.controls['resubReason']){
        <div nz-col [nzSm]="4" [nzXs]="24" class="radio-group-container">
            <nz-form-item>
                <nz-form-label nzFor="resubReason" class="ppl-form-label report-label">
                    Resub Reason
                </nz-form-label>
                <nz-form-control style="width: 100%">
                    <div>
                        <ppl-dropdown-select formControlName="resubReason" class="ppl-select" id="resubReason"
                            [options]="resubReasonList" [optionLabel]="'resubReason'" [optionValue]="'resubReason'"
                            placeholder="Resub Reason" />
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        }
        @if(reportFilterForm.controls['batchDate']){
        <div nz-col [nzSm]="4" [nzXs]="24">
            <nz-form-item style="margin-bottom:8px; width: 100%">
                <nz-form-label nzFor="batchDate" class="ppl-form-label report-label">
                    Batch Date
                </nz-form-label>
                <nz-form-control style="width: 100%">
                    <div>
                        <ppl-dropdown-select formControlName="batchDate" id="batchDate" [options]="batchDates"
                            style="width: 100%;" placeholder="Batch Date"></ppl-dropdown-select>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
        }
        @if(reportFilterForm.controls['selectedClaimType']){
        <div nz-col [nzSm]="4" [nzXs]="24">
            <nz-form-item>
                <nz-form-label nzFor="claimType" class="ppl-form-label report-label">
                    Claim Type
                </nz-form-label>
                <nz-form-control>
                    <ppl-dropdown-select formControlName="selectedClaimType" class="ppl-select" id="claimType"
                        [options]="claimTypes" [optionLabel]="'label'" [optionValue]="'value'"
                        placeholder="Claim Type" />
                </nz-form-control>
            </nz-form-item>
        </div>
        }
    </div>
</form>